import cx from 'classnames';
import { HomeBannerProps } from './HomeBanner.type';

const HomeBanner = ({
  className,
  bannerImage,
  bannerTitle,
  bannerSubtitle,
  bannerText,
  appDownloadList,
}: HomeBannerProps) => {
  const mergedClassName = cx('home-banner-container', className);

  return (
    <div className={mergedClassName}>
      <div className="triangle" />
      <img src={bannerImage} className="banner-image" alt="home-page-banner" />
      <div className="content-container">
        <div className="title">{bannerTitle}</div>
        <div className="subtitle">{bannerSubtitle}</div>
        <div className="app-download-container">
          <div className="text">{bannerText}</div>
          <div
            className={`app-download-list ${
              appDownloadList.length % 3 === 0 ? 'three-column' : ''
            }`}
          >
            {appDownloadList.map((item) => (
              <a href={item.link} key={item.link} className="download-icon">
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export type { HomeBannerProps };
export default HomeBanner;
